<template>
  <div id="mheader">
    <div class="mheader trans3" :class="{'bgray':ishow}">
      <!-- 导航 -->
      <div class="allbox mbflex box1" :class="{'hei1':clink==1}">
        <router-link to="/"><img :src="pubImg + 'logo.png'" class="mlogo"></router-link>
        <div class="mbflex-dw8 mbflex navbox">
          <router-link class="dl" :class="{'act':clink==item.id}" v-for="item in linkList" :to="item.url"
            :key="item.id">
            {{item.name}}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'mheader',
    data() {
      return {
        pubImg: localStorage.getItem("pubImg"), //图片路径
        pubPostUrl: localStorage.getItem("pubPostUrl"), //接口前缀
        linkList: [{
            id: 1,
            name: "网站首页",
            url: "/",
          }, {
            id: 2,
            name: "别墅案例",
            url: "/case",
          }, {
            id: 3,
            name: "设计团队",
            url: "/team",
          }, {
            id: 4,
            name: "专属工程",
            url: "/project",
          },
          {
            id: 6,
            name: "品牌介绍",
            url: "/about",
          },
          {
            id: 5,
            name: "新闻资讯",
            url: "/news",
          },
          {
            id: 7,
            name: "联系我们",
            url: "/contact",
          }
        ], //导航链接
      }
    },

    props: {
      clink: Number, //当前链接
      ishow: Boolean, //是否显示深黑色背景
    },
    created() {
      let that = this;
      that.mpublic.pageScrrolTop();
    },
    
    methods: {

    }
  }
</script>

<style>
  /* 头部 */
  .mheader {
    width: 100%;
    background: rgba(0, 0, 0, .3);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 99;
    overflow: hidden;
  }
  .mheader.bgray{
    background: rgba(0, 0, 0, .4);
    -webkit-backdrop-filter: blur(12px);
    backdrop-filter: blur(12px);
    transform: translateZ(0);
  }

  .mheader .box1 {
    height: 7rem;
    justify-content: flex-start;
  }

  .mheader .mlogo {
    height: 3.3rem;
  }

  .mheader .navbox {
    margin-left: 10%;
  }

  .mheader .navbox .dl {
    color: #FFFFFF;
  }

  .mheader .navbox .dl::after {
    content: "";
    display: block;
    width: 0;
    height: 2px;
    background: #FFFFFF;
    margin: 8px 2px 0;
    transition: all .3s;
  }

  .mheader .navbox .dl.act::after {
    width: 50%;
  }


</style>



// WEBPACK FOOTER //
// src/components/mheader.vue